$(() => {
  $('#blog-search-field-id').on('keydown', e => {
    // preventing user from submitting form when clicking 'enter'.
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  const handleClick = e => {
    if (!$('.blog-sort-dropdown')[0].contains(e.target)) {
      $('.blog-sort-dropdown').removeClass('hidden');
      document.removeEventListener('click', handleClick);
    }
  };

  $('#blog-sort-by').click(e => {
    e.preventDefault();
    e.stopPropagation();
    if (!$('.blog-sort-dropdown').hasClass('hidden')) {
      document.addEventListener('click', handleClick);
      $('.blog-sort-dropdown').removeClass('hidden');
    } else {
      document.removeEventListener('click', handleClick);
      $('.blog-sort-dropdown').toggleClass('hidden');
    }
  });
});
